import { createContext, type ReactNode, useContext } from 'react';

import type { EditorAdapter } from './types';

const EditorAdapterContext = createContext<EditorAdapter | null>(null);

export function useEditorAdapter(): EditorAdapter {
    const adapter = useContext(EditorAdapterContext);
    if (!adapter) {
        throw new Error(
            'useEditorAdapter must be used within an <EditorAdapterProvider>'
        );
    }
    return adapter;
}

interface EditorAdapterProviderProps {
    adapter: EditorAdapter;
    children: ReactNode;
}

export function EditorAdapterProvider({
    adapter,
    children
}: EditorAdapterProviderProps) {
    return (
        <EditorAdapterContext.Provider value={adapter}>
            {children}
        </EditorAdapterContext.Provider>
    );
}
